


















// @ is an alias to /src
import Vue from "vue";

import PuzzleGrid from "@/components/PlayArea/PuzzleGrid.vue";
import { frontPuzzle } from "../services/misc/preview";
import { PuzzleData } from "../services/vo";
import { PuzzleResponse, Game, VueConstructor } from "vue/types/vue";

export default (Vue as VueConstructor<
  Vue & {
    $refs: {
      game: Game;
    };
  }
>).extend({
  name: "home",
  components: {
    PuzzleGrid
  },
  data() {
    return {
      puzzle: new PuzzleData()
    };
  },
  computed: {
    getPuzzle: function(): PuzzleData {
      this.puzzle.setWordStarts(frontPuzzle.wordStarts);
      this.puzzle.setArrows(frontPuzzle.arrows);
      this.puzzle.setState(frontPuzzle.state);

      return this.puzzle;
    }
  }
});
